/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/templates/blogpost/products.js":
/*!****************************************************!*\
  !*** ./zrc/scripts/templates/blogpost/products.js ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../helpers/set-height-elements-v2 */ \"./zrc/scripts/helpers/set-height-elements-v2.js\");\n/* harmony import */ var _components_product_card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../components/product-card */ \"./zrc/scripts/components/product-card.js\");\n\n\n\n(0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_0__.register)('blogpost-products-section', {\n  onLoad() {\n    this.handleGridOverflow();\n    this.alignCardText();\n    new _components_product_card__WEBPACK_IMPORTED_MODULE_2__.default(this.container);\n  },\n  handleGridOverflow() {\n    // Function para poder hacer el cambio de golpe del diseño \"rebasado\" de las tags al hacer resize\n\n    // seleccionamos el wrapper general de los botones.\n    var $productsRow = this.container.querySelector('.blogpost-products-grid-wrapper');\n\n    // seleccionamos el div con overflow\n    var $containerToCheck = $productsRow.querySelector('.blogpost-products-grid-wrapper-overflow');\n    function addClassToWrapper() {\n      // Funcion para que añada una clase al wrapper una vez que este tenga una barra horizontal\n\n      // Quitamos la clase primero, para que se calcule todo en su \"Estado normal\"\n      $productsRow.classList.remove('js-has-scroll');\n\n      // hacemos el chequeo de si tiene barra horizontal\n      var hasHorizontalScrollbar = $containerToCheck.scrollWidth > $containerToCheck.clientWidth;\n\n      // Si es que no se tiene barra horizontal, ya no hacemos nada.\n      if (hasHorizontalScrollbar === false) {\n        return;\n      }\n\n      // añadimos la clase en caso de tener barra horizontal\n      $productsRow.classList.add('js-has-scroll');\n    }\n    function checkIfScrollReachedEnd() {\n      if ($productsRow.classList.contains('js-has-scroll') === false) {\n        return;\n      }\n      var maxScroll = $containerToCheck.scrollWidth - $containerToCheck.clientWidth;\n      var currentScrollPosition = $containerToCheck.scrollLeft;\n      if (currentScrollPosition !== maxScroll) {\n        $productsRow.classList.remove('js-scroll-end');\n        return;\n      }\n      $productsRow.classList.add('js-scroll-end');\n    }\n\n    // declaramos el observador, y lo que hara\n    var resizeObserver = new window.ResizeObserver(() => {\n      addClassToWrapper();\n    });\n\n    // inicializamos el observador para que \"vea\" el resize de solo el elemento que queremos.\n    resizeObserver.observe($productsRow);\n    addClassToWrapper();\n    $containerToCheck.addEventListener('scroll', checkIfScrollReachedEnd);\n  },\n  alignCardText() {\n    // Funcion para alinear los textos de las tarjetas entre si.\n\n    // Seleccionamos todos los wrappers que necesitamos\n    var $titles = this.container.querySelectorAll(\".product-card-title\");\n    var $summary = this.container.querySelectorAll(\".product-card-summary-text\");\n    var $stars = this.container.querySelectorAll(\".product-card-stars\");\n\n    // configuracion del componente\n    var options = {\n      cssVariable: \"--min-height\"\n    };\n\n    // inicializamos la alineacion\n    this.container.titlesCalculation = new _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_1__.ElementsHeightCalculation($titles, options);\n    this.container.starsCalculation = new _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_1__.ElementsHeightCalculation($stars, options);\n    this.container.summaryCalculation = new _helpers_set_height_elements_v2__WEBPACK_IMPORTED_MODULE_1__.ElementsHeightCalculation($summary, options);\n  }\n});\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/templates/blogpost/products.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"blogpost-products": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/templates/blogpost/products.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkgetmore_workflow"] = self["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;